(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.inga-reveal').forEach((el) => {
      el.classList.add('inga-reveal--visible');
    });
  }

  if (reducedMotion) {
    revealAll();
    return;
  }

  function init() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('inga-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: isMobile ? 0.01 : 0.08,
        rootMargin: isMobile ? '0px 0px 8% 0px' : '0px 0px -4% 0px',
      }
    );

    document.querySelectorAll('.inga-reveal:not(.inga-reveal--visible)').forEach((el) => {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.setTimeout(revealAll, 2500);
})();
